import { Stack } from "expo-router";
import { Platform } from "react-native";
import "react-native-reanimated";
import { AppEntry } from "~/AppEntry";
import { Header } from "~/components/Header";

export default function RootLayout() {
  return (
    <AppEntry>
      <Stack
        screenOptions={{
          header: (props) => <Header {...props} />,
          gestureEnabled: false,
          headerShown: Platform.OS === "web" ? false : true,
        }}
      >
        <Stack.Screen name="login" options={{ headerShown: false }} />
        <Stack.Screen name="+not-found" />
        <Stack.Screen name="index" options={{ headerShown: false }} />
        <Stack.Screen
          name="video-settings"
          options={{
            headerShown: Platform.OS !== "web",
          }}
        />
        <Stack.Screen name="video-chat" options={{ headerShown: false }} />

        {/* Croatian */}
        <Stack.Screen name="hr/index" options={{ headerShown: false }} />
        <Stack.Screen
          name="hr/video-settings"
          options={{
            headerShown: Platform.OS !== "web",
          }}
        />
        <Stack.Screen name="hr/video-chat" options={{ headerShown: false }} />
      </Stack>
    </AppEntry>
  );
}
